<script>
import NotificationAppBar from "@/views/Notification/NotificationAppBar.vue";
import {onMounted, ref} from "vue";
import useTools from "@/use/Tools";
import {useSecurityStore} from "@/stores/Security";
import {storeToRefs} from "pinia";
import WorkerImage from "@/views/Worker/Components/WorkerImage.vue";

import useSharedMethod from "@/use/SharedMethod";

export default {
    components: {WorkerImage, NotificationAppBar},
    setup() {
        const {$route, $i18n} = useTools();
        const {logout} = useSharedMethod();
        const securityStore = useSecurityStore();
        const drawer = ref(true);
        const mini_variant = ref(false);
        const item = ref("workers");
        const {snackbar} = storeToRefs(securityStore);
        const items = ref([
            {
                action: "mdi-monitor-dashboard",
                title: "Dashboard",
                active: ["notifications"].includes($route.name),
                access: securityStore.authorities['READ_WORKER'] || securityStore.authorities['READ_CONTRAT'],
                items: [
                    {
                        title: $i18n.t("module.notification"),
                        action: "mdi-bell",
                        link: "notifications",
                        access: true,
                    },
                    {
                        title: $i18n.t("module.issue"),
                        action: "mdi-bug",
                        link: "issues",
                        access: true,
                    },
                    /*{
                        title: $i18n.t("module.dashboard"),
                        action: "mdi-desktop-mac-dashboard",
                        link: "dashboard",
                        access: true,
                        disabled: true,
                    },*/
                ],
            },
            {
                action: "mdi-account-convert",
                title: "Recrutement",
                active: [
                    "recruitment_requests",
                    "recruitment_sourcings",
                    "recruitment_sourcings.add",
                    "recruitment_plannings",
                    "recruitment_evaluations",
                    "recruitment_decisions",
                    "on_boardings",
                    "off_boardings",
                    "boarding_tasks",
                    "boarding_process_models",
                    "boarding_task_models",
                    "recruitment_cv_techs",
                ].includes($route.name),
                access: securityStore.authorities['READ_RECRUITMENT_REQUEST'] ||
                    securityStore.authorities['READ_RECRUITMENT_SOURCING'] ||
                    securityStore.authorities['READ_RECRUITMENT_PLANNING'] ||
                    securityStore.authorities['READ_RECRUITMENT_EVALUATION'] ||
                    securityStore.authorities['READ_RECRUITMENT_REQUEST'] ||
                    securityStore.authorities['READ_BOARDING'] ||
                    securityStore.authorities['READ_RECRUITMENT_CV_TECH'],
                items: [
                    {
                        title: $i18n.t("module.recruitment_request"),
                        action: "mdi-account-convert",
                        link: "recruitment_requests",
                        access: securityStore.authorities['READ_RECRUITMENT_REQUEST'],
                    },
                    {
                        title: $i18n.t("module.recruitment_sourcing"),
                        action: "mdi-text-box-search",
                        link: "recruitment_sourcings",
                        access: securityStore.authorities['READ_RECRUITMENT_SOURCING'],
                    },
                    {
                        title: $i18n.t("module.recruitment_planning"),
                        action: "mdi-calendar-clock",
                        link: "recruitment_plannings",
                        access: securityStore.authorities['READ_RECRUITMENT_PLANNING'],
                    },
                    {
                        action: "mdi-school",
                        title: "Evaluation",
                        active: [
                            "recruitment_evaluations",
                            "recruitment_decisions"
                        ].includes($route.name),
                        access: securityStore.authorities['READ_RECRUITMENT_EVALUATION'],
                        subGroups: [
                            {
                                title: $i18n.t("module.recruitment_evaluation"),
                                action: "mdi-school",
                                link: "recruitment_evaluations",
                                access: securityStore.authorities['READ_RECRUITMENT_EVALUATION'],
                            },
                            {
                                title: $i18n.t("module.recruitment_decision"),
                                action: "mdi-arrow-decision",
                                link: "recruitment_decisions",
                                access: securityStore.authorities['READ_RECRUITMENT_EVALUATION'],
                            },
                        ],
                    },
                    {
                        action: "mdi-skateboarding",
                        title: "On/Off Boarding",
                        active: [
                            "on_boardings",
                            "off_boardings",
                            "boarding_tasks",
                        ].includes($route.name),
                        access: securityStore.authorities['READ_BOARDING'],
                        subGroups: [
                            {
                                title: $i18n.t("module.on_boarding"),
                                action: "mdi-skateboarding",
                                link: "on_boardings",
                                access: securityStore.authorities['READ_BOARDING'],
                            },
                            {
                                title: $i18n.t("module.off_boarding"),
                                action: "mdi-engine-off",
                                link: "off_boardings",
                                access: securityStore.authorities['READ_BOARDING'],
                            },
                            {
                                title: $i18n.t("module.boarding_task"),
                                action: "mdi-calendar-check",
                                link: "boarding_tasks",
                                access: securityStore.authorities['READ_BOARDING'],
                            },
                        ],
                    },
                    {
                        title: $i18n.t('module.cv_tech'),
                        action: "mdi-database",
                        link: "recruitment_cv_techs",
                        access: securityStore.authorities['READ_RECRUITMENT_CV_TECH'],
                    },
                ],
            },
            {
                action: "mdi-account-tie-outline",
                title: "Administration",
                active: [
                    "organizational_charts",
                    "workers",
                    "contrats",
                    "contrat_templates",
                    "absence_requests",
                    "claims",
                    "admin_requests",
                    "vacations",
                    "vacation_balance",
                    "vacations_calendar",
                    "debts",
                    "pay_day_advances",
                    "absence_requests_balance",
                ].includes($route.name),
                access: securityStore.authorities['READ_ORGANIZATIONAL_CHART'] ||
                    securityStore.authorities['READ_WORKER'] ||
                    securityStore.authorities['READ_CONTRAT'] ||
                    securityStore.authorities['READ_ABSENCE_REQUEST'] ||
                    securityStore.authorities['READ_CLAIM'] ||
                    securityStore.authorities['READ_ADMIN_REQUEST'] ||
                    securityStore.authorities['READ_CONTRAT_TEMPLATE'] ||
                    securityStore.authorities['READ_WORKER_BALANCE'] ||
                    securityStore.authorities['READ_DEBT'],
                items: [
                    {
                        title: $i18n.t("module.organizational_chart"),
                        action: "mdi-circle-double",
                        link: "organizational_charts",
                        access: securityStore.authorities['READ_ORGANIZATIONAL_CHART'],
                    },
                    {
                        title: $i18n.t("module.worker"),
                        action: "mdi-account-tie-outline",
                        link: "workers",
                        access: securityStore.authorities['READ_WORKER'],
                    },
                    {
                        action: "mdi-book-open-page-variant",
                        title: "Gestion Contrat",
                        active: [
                            "contrats",
                            "contrat_templates",
                        ].includes($route.name),
                        access: securityStore.authorities['READ_CONTRAT'] ||
                            securityStore.authorities['READ_CONTRAT_TEMPLATE'],
                        subGroups: [
                            {
                                title: $i18n.t("module.contrat"),
                                action: "mdi-book-open-page-variant",
                                link: "contrats",
                                access: securityStore.authorities['READ_CONTRAT'],
                            },
                            {
                                title: $i18n.t("module.contrat_template"),
                                action: "mdi-book-cog",
                                link: "contrat_templates",
                                access: securityStore.authorities['READ_CONTRAT_TEMPLATE'],
                            },
                        ],
                    },
                    {
                        action: "mdi-bullhorn",
                        title: "Demande",
                        active: [
                            "absence_requests",
                            "claims",
                            "admin_requests"
                        ].includes($route.name),
                        access: securityStore.authorities['READ_ABSENCE_REQUEST'] ||
                            securityStore.authorities['READ_CLAIM'] ||
                            securityStore.authorities['READ_ADMIN_REQUEST'],
                        subGroups: [
                            {
                                title: $i18n.t("module.absence_request"),
                                action: "mdi-exit-run",
                                link: "absence_requests",
                                access: securityStore.authorities['READ_ABSENCE_REQUEST'],
                            },
                            {
                                title: $i18n.t('module.claim'),
                                action: "mdi-badge-account-alert",
                                link: "claims",
                                access: securityStore.authorities['READ_CLAIM'],
                            },
                            {
                                title: $i18n.t('module.admin_request'),
                                action: "mdi-text-box-multiple",
                                link: "admin_requests",
                                access: securityStore.authorities['READ_ADMIN_REQUEST'],
                            },
                        ],
                    },
                    {
                        action: "mdi-airplane-takeoff",
                        title: "Gestion Congé",
                        active: [
                            "vacations",
                            "vacation_balance",
                            "vacations_calendar"
                        ].includes($route.name),
                        access: securityStore.authorities['READ_ABSENCE_REQUEST'] ||
                            securityStore.authorities['READ_WORKER_BALANCE'],
                        subGroups: [
                            {
                                title: $i18n.t("module.vacation"),
                                action: "mdi-airplane-takeoff",
                                link: "vacations",
                                access: securityStore.authorities['READ_ABSENCE_REQUEST'],
                            },
                            {
                                title: "Solde",
                                action: "mdi-cash-100",
                                link: "vacation_balance",
                                access: securityStore.authorities['READ_WORKER_BALANCE'],
                            },
                            {
                                title: $i18n.t("module.planning"),
                                action: "mdi-calendar-clock",
                                link: "vacations_calendar",
                                access: securityStore.authorities['READ_ABSENCE_REQUEST'],
                            },
                        ],
                    },
                    {
                        title: "Gestion Pret",
                        action: "mdi-cash-multiple",
                        active: [
                            "debts",
                            "pay_day_advances",
                        ].includes($route.name),
                        access: securityStore.authorities['READ_DEBT'],
                        subGroups: [
                            {
                                title: $i18n.t("module.debt"),
                                action: "mdi-cash-multiple",
                                link: "debts",
                                access: securityStore.authorities['READ_DEBT'],
                            },
                            {
                                title: $i18n.t("module.pay_day_advance"),
                                action: "mdi-run-fast",
                                link: "pay_day_advances",
                                access: securityStore.authorities['READ_DEBT'],
                            },
                        ],
                    },
                    {
                        title: "Solde",
                        action: "mdi-cash-100",
                        link: "absence_requests_balance",
                        access: securityStore.authorities['READ_WORKER_BALANCE'],
                    },
                ],
            },
            /*{
                action: "mdi-alarm-bell",
                title: "Pointage",
                active: ["journal_pointings", "periodic_pointings"].includes($route.name),
                items: [
                    {
                        title: "Pointage",
                        action: "mdi-alarm",
                        link: "journal_pointings",
                        access: true,
                    },
                    {
                        title: "Synthèse",
                        action: "mdi-alarm-multiple",
                        link: "periodic_pointings",
                        access: true,
                    },
                ],
            },*/
            {
                action: "mdi-account-credit-card",
                title: "Paie",
                active: [
                    "pay_slips",
                    "pay_slip_annexes",
                    "declaration_cotisation",
                    "blank_pay_slips",
                    "grille",
                    "categories",
                    "classes",
                ].includes($route.name),
                access: securityStore.authorities['READ_PAY_SLIP'] ||
                    securityStore.authorities['READ_PAY_SLIP_ANNEX'] ||
                    securityStore.authorities['READ_GRILLE'],
                items: [
                    {
                        title: $i18n.t("module.write_pay"),
                        action: "mdi-account-credit-card",
                        link: "pay_slips",
                        access: securityStore.authorities['READ_PAY_SLIP'],
                    },
                    {
                        title: $i18n.t("module.pay_slip_synthesis"),
                        action: "mdi-sigma",
                        link: "pay_slip_annexes",
                        access: securityStore.authorities['READ_PAY_SLIP_ANNEX'],
                    },
                    {
                        title: $i18n.t("module.impression"),
                        action: "mdi-cloud-print",
                        link: "declaration_cotisation",
                        access: securityStore.authorities['READ_PAY_SLIP'],
                    },
                    {
                        title: $i18n.t("module.blank_pay_slips"),
                        action: "mdi-checkbox-blank-outline",
                        link: "blank_pay_slips",
                        access: securityStore.authorities['READ_PAY_SLIP'],
                    },
                    {
                        title: "Grille de Salaire",
                        action: "mdi-account-cash",
                        link: "grille",
                        access: securityStore.authorities['READ_GRILLE'],
                    },
                ],
            },
            {
                action: "mdi-puzzle-star-outline",
                title: "Développement RH",
                active: [
                    "evaluation_skill_directories",
                    "evaluation_skill_frameworks",
                    "evaluation_skill_goal_files",
                    "evaluation_skills",
                    "evaluation_skill_candidates",
                    "evaluation_performance_goal_files",
                    "evaluation_performances",
                    "evaluation_performance_candidates",
                    "training_request_catalogs",
                    "training_plans",
                    "training_plan_details",
                    "training_requests",
                    "training_sessions",
                    "training_hot_evaluations",
                    "training_cold_evaluations",
                    "training_pointings",
                ].includes($route.name),
                access: securityStore.authorities['READ_EVALUATION_SKILL'] || securityStore.authorities['READ_EVALUATION_PERFORMANCE'],
                items: [
                    {
                        action: "mdi-speedometer",
                        title: "Evaluation Performances",
                        active: [
                            'evaluation_performances',
                            'evaluation_performance_candidates',
                            'evaluation_performance_goal_files'
                        ].includes($route.name),
                        access: securityStore.authorities['READ_EVALUATION_PERFORMANCE'],
                        subGroups: [
                            {
                                action: "mdi-bullseye-arrow",
                                title: $i18n.t('module.evaluation_performance_goal_files'),
                                link: "evaluation_performance_goal_files",
                                access: securityStore.authorities['READ_EVALUATION_PERFORMANCE'],
                            },
                            {
                                action: "mdi-floor-plan",
                                title: $i18n.t('module.evaluation_performances'),
                                link: "evaluation_performances",
                                access: securityStore.authorities['READ_EVALUATION_PERFORMANCE'],
                            },
                            {
                                action: "mdi-clipboard-text-clock",
                                title: $i18n.t('module.evaluation_performance_candidates'),
                                link: "evaluation_performance_candidates",
                                access: securityStore.authorities['READ_EVALUATION_PERFORMANCE'],
                            },
                        ],
                    },
                    {
                        action: "mdi-hammer-wrench",
                        title: "Evaluation Compétences",
                        active: [
                            "evaluation_skill_directories",
                            "evaluation_skill_frameworks",
                            "evaluation_skill_goal_files",
                            "evaluation_skills",
                            "evaluation_skill_candidates",
                        ].includes($route.name),
                        access: securityStore.authorities['READ_EVALUATION_SKILL'],
                        subGroups: [
                            {
                                action: "mdi-folder-open",
                                title: $i18n.t('module.evaluation_skill_directory'),
                                link: "evaluation_skill_directories",
                                access: true
                            },
                            {
                                action: "mdi-source-branch",
                                title: $i18n.t('module.evaluation_skill_framework'),
                                link: "evaluation_skill_frameworks",
                                access: true
                            },
                            {
                                action: "mdi-bullseye-arrow",
                                title: $i18n.t('module.evaluation_skill_goal_files'),
                                link: "evaluation_skill_goal_files",
                                access: securityStore.authorities['READ_EVALUATION_SKILL'],
                            },
                            {
                                action: "mdi-floor-plan",
                                title: $i18n.t('module.evaluation_skills'),
                                link: "evaluation_skills",
                                access: securityStore.authorities['READ_EVALUATION_SKILL'],
                            },
                            {
                                action: "mdi-clipboard-text-clock",
                                title: $i18n.t('module.evaluation_skill_candidates'),
                                link: "evaluation_skill_candidates",
                                access: securityStore.authorities['READ_EVALUATION_SKILL'],
                            },
                        ],
                    },
                    {
                        action: "mdi-account-school",
                        title: $i18n.t('module.training'),
                        active: [
                            "training_request_catalogs",
                            "training_plans",
                            "training_plan_details",
                            "training_requests",
                            "training_sessions",
                            "training_hot_evaluations",
                            "training_cold_evaluations",
                            "training_pointings",
                        ].includes($route.name),
                        access: securityStore.authorities['READ_TRAINING_REQUEST'] ||
                            securityStore.authorities['READ_TRAINING_PLAN'] ||
                            securityStore.authorities['READ_TRAINING_SESSION'] ||
                            securityStore.authorities['READ_TRAINING_PARAM'],
                        subGroups: [
                            {
                                title: $i18n.t("module.training_catalog"),
                                action: "mdi-book-cog",
                                link: "training_request_catalogs",
                                access: securityStore.authorities['READ_TRAINING_PARAM'],
                            },
                            {
                                title: $i18n.t("module.training_plan"),
                                action: "mdi-floor-plan",
                                link: "training_plans",
                                access: securityStore.authorities['READ_TRAINING_PLAN'],
                            },
                            {
                                title: $i18n.t("module.training_request"),
                                action: "mdi-cast-education",
                                link: "training_requests",
                                access: securityStore.authorities['READ_TRAINING_REQUEST'],
                            },
                            {
                                title: $i18n.t("module.training_session"),
                                action: "mdi-fan-clock",
                                link: "training_sessions",
                                access: securityStore.authorities['READ_TRAINING_SESSION'],
                            },
                            {
                                title: $i18n.t("module.training_hot_evaluations"),
                                action: "mdi-fire-circle",
                                link: "training_hot_evaluations",
                                access: securityStore.authorities['READ_TRAINING_SESSION'],
                            },
                            {
                                title: $i18n.t("module.training_cold_evaluations"),
                                action: "mdi-snowflake",
                                link: "training_cold_evaluations",
                                access: securityStore.authorities['READ_TRAINING_SESSION'],
                            }
                        ],
                    },
                ]
            },
            
            {
                action: "mdi-bottle-tonic-plus",
                title: $i18n.t('module.medical'),
                active: ["medical_companions", "medical_appointments"].includes($route.name),
                access: true,
                items: [
                    {
                        title: $i18n.t("module.medical_companion"),
                        action: "mdi-clipboard-pulse",
                        link: "medical_companions",
                        access: true,
                    },
                    {
                        title: $i18n.t("module.medical_appointment"),
                        action: "mdi-calendar-heart",
                        link: "medical_appointments",
                        access: true,
                    },
                ],
            },
            {
                action: "mdi-cloud-sync",
                title: $i18n.t("module.document"),
                active: [
                    "documents",
                    "template_applications"
                ].includes($route.name),
                access: securityStore.authorities['READ_DOCUMENT'],
                items: [
                    {
                        title: $i18n.t("module.edms"),
                        action: "mdi-folder",
                        link: "documents",
                        access: securityStore.authorities['READ_DOCUMENT'],
                    },
                    {
                        title: $i18n.t("module.template_application"),
                        action: "mdi-folder",
                        link: "template_applications",
                        access: securityStore.authorities['READ_DOCUMENT'],
                    },
                ],
            },
            /*{
                action: "mdi-police-badge",
                title: $i18n.t("module.disciplinary_regime"),
                active: ["disciplinary_regimes", "mistakes", "sanctions", "printing_models"].includes($route.name),
                items: [
                    {
                        title: $i18n.t("module.disciplinary_regime"),
                        action: "mdi-police-badge",
                        link: "disciplinary_regimes",
                        access: true,
                    },
                    {
                        title: $i18n.t("module.mistake"),
                        action: "mdi-bash",
                        link: "mistakes",
                        access: true,
                    },
                    {
                        title: $i18n.t("module.sanction"),
                        action: "mdi-gavel",
                        link: "sanctions",
                        access: true,
                    },
                    {
                        title: $i18n.t("module.printing_model"),
                        action: "mdi-printer",
                        link: "printing_models",
                        access: true,
                    },
                ],
            },
            {
                action: "mdi-barley",
                title: "Gestion Sociale",
                active: [
                    "cnass",
                    "shifa_carts",
                    "diseases",
                    "cares",
                    "bordereaux",
                ].includes($route.name),
                items: [
                    {
                        title: $i18n.t("CNAS"),
                        action: "mdi-badge-account",
                        link: "cnass",
                        access: true,
                    },
                    {
                        title: $i18n.t("module.shifa_cart"),
                        action: "mdi-card-bulleted-settings",
                        link: "shifa_carts",
                        access: true,
                    },
                    {
                        title: $i18n.t("module.diseases"),
                        action: "mdi-hospital-building",
                        link: "diseases",
                        access: true,
                    },
                    {
                        title: $i18n.t("module.cares"),
                        action: "mdi-doctor",
                        link: "cares",
                        access: true,
                    },
                    {
                        title: $i18n.t("module.bordereaux"),
                        action: "mdi-ballot",
                        link: "bordereaux",
                        access: true,
                    },
                ],
            },*/
            {
                action: "mdi-abugida-thai ",
                title: $i18n.t("module.validation_work_flow"),
                active: [
                    "validation_work_flows",
                    "validation_work_flow_actions",
                ].includes($route.name),
                access: securityStore.authorities['READ_WORKFLOW'],
                items: [
                    {
                        title: $i18n.t("module.validation_work_flow"),
                        action: "mdi-sitemap",
                        link: "validation_work_flows",
                        access: securityStore.authorities['READ_WORKFLOW'],
                    },
                    {
                        title: $i18n.t("module.validation_work_flow_action"),
                        action: "mdi-gesture-tap-button",
                        link: "validation_work_flow_actions",
                        access: securityStore.authorities['READ_WORKFLOW'],
                    },
                ],
            },
        ]);
        
        function hasParamAccess() {
            return securityStore.authorities['READ_GENERAL_PARAM'] ||
                securityStore.authorities['READ_IMPORT_PARAM'] ||
                securityStore.authorities['READ_RECRUITMENT_PARAM'] ||
                securityStore.authorities['READ_ADMIN_PARAM'] ||
                securityStore.authorities['READ_PAY_SLIP_PARAM'] ||
                securityStore.authorities['READ_ABSENCE_REQUEST_PARAM'] ||
                securityStore.authorities['READ_TRAINING_PARAM'] ||
                securityStore.authorities['READ_EVALUATION_PARAM'] ||
                securityStore.authorities['READ_DOCUMENT_PARAM'] ||
                securityStore.authorities['READ_NOTIFICATION_PARAM'] ||
                securityStore.authorities['READ_PRIVILEGE_PARAM'];
        }
        
        function isParamActive() {
            return [
                "parameters",
                "general_configuration",
                "folders",
                "codifications",
                "data_selects",
                "additional_fields",
                "emails",
                "cnas_agency_tools",
                "occupation_tools",
                "worker_tools",
                "debt_tools",
                "pay_section_tools",
                "pay_slip_tools",
                "assigned_pay_section_tools",
                "irg_tools",
                "recruitments_configuration",
                "boarding_task_models",
                "boarding_process_models",
                "workers_configuration",
                "cnas_agencies",
                "occupations",
                "set_occupations",
                "pay_slips_configuration",
                "pay_sections",
                "default_pay_sections",
                "auto_pay_sections",
                "import_models",
                "out_state_models",
                "banks",
                "validation_work_flows_configuration",
                "balances",
                "absence_reasons",
                "training_requests_configuration",
                "scorecards",
                "schools",
                "catalogs",
                "question_select_types",
                "evaluation_plans_configuration",
                "evaluation_skill_gravities",
                "evaluation_skill_criterion_category",
                "evaluation_skill_criterion",
                "evaluation_skill_files",
                "evaluation_performance_gravities",
                "evaluation_performance_criterion_category",
                "evaluation_performance_criterion",
                "evaluation_performance_files",
                "evaluation_recruitment_gravities",
                "evaluation_recruitment_criterion_category",
                "evaluation_recruitment_criterion",
                "evaluation_recruitment_files",
                "evaluation_training_hot_gravities",
                "evaluation_training_hot_criterion_category",
                "evaluation_training_hot_criterion",
                "evaluation_training_hot_files",
                "evaluation_training_cold_gravities",
                "evaluation_training_cold_criterion_category",
                "evaluation_training_cold_criterion",
                "evaluation_training_cold_files",
                "templates",
                "header_templates",
                "footer_templates",
                "personalized_variables",
                "alarms_configuration",
                "alarms",
                "control_programs",
                "control_issues",
                "users_configuration",
                "roles",
                "users",
                "privileges",
            ].includes($route.name);
        }
        
        const isHeaderAndFooterEnabled = ref(false);
        const headerHtml = ref(null);
        const footerHtml = ref(null);
        
        /*function loadHeaderAndFooter() {
            new Promise((resolve) => {
                setTimeout(() => {
                    resolve({
                        data: {
                            header: `
                        <div style="background:#00897b; color:white; padding:8px 16px;">
                            <strong>Company Name</strong><br/>
                            <small>Extra info line</small>
                        </div>
                    `
                        }
                    })
                }, 1000)
            }).then(response => {
                headerHtml.value = response.data.header
            })
        }*/
        
        onMounted(() => {
            // loadHeaderAndFooter();
            /* setInterval(() => {
                 testConnection();
             }, 20000);*/
        });
        
        return {
            securityStore,
            drawer,
            mini_variant,
            item,
            items,
            snackbar,
            isHeaderAndFooterEnabled,
            headerHtml,
            footerHtml,
            logout,
            hasParamAccess,
            isParamActive,
        }
    },
    mounted() {
    
    },
    methods: {},
};
</script>

<template>
    <div class="home">
        <!--<div
            ref="customHeader"
            v-if="headerHtml"
            v-html="headerHtml"
        ></div>-->
        <v-app-bar
            height="45"
            :clipped-left="$vuetify.breakpoint.lgAndUp"
            app
            color="grey lighten-5"
            dense
        >
            
            <v-app-bar-nav-icon @click="mini_variant= !mini_variant"></v-app-bar-nav-icon>
            <v-toolbar-title>{{ $t("app_name") }}</v-toolbar-title>
            <v-spacer/>
            <NotificationAppBar/>
        </v-app-bar>
        <nav>
            <v-navigation-drawer
                width="310"
                mini-variant-width="70"
                dense
                v-model="drawer"
                :mini-variant="mini_variant"
                :clipped="$vuetify.breakpoint.lgAndUp"
                app
            
            >
                <v-img
                    height="100"
                    :src="`${securityStore.getImageLink()}/drawer-background.jpg`"
                >
                    <v-row justify="center" align="center">
                        <v-col cols="12">
                            <v-list dense nav class="py-0">
                                <v-list-item two-line>
                                    <v-list-item-avatar>
                                        <WorkerImage
                                            :worker-id="securityStore.userContext.workerId"
                                            disable-card
                                            readonly
                                        />
                                    </v-list-item-avatar>
                                    
                                    <v-list-item-content>
                                        <v-list-item-title class="white--text subtitle-1">
                                            <strong>{{ securityStore.userContext.fullName }}</strong>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-col>
                    </v-row>
                </v-img>
                <v-list dense nav>
                    <template
                        v-for="item in items"
                    >
                        <v-list-group
                            color="teal"
                            :key="item.title"
                            v-model="item.active"
                            v-show="item.access"
                            :prepend-icon="item.action"
                            no-action
                        >
                            <template v-slot:activator>
                                <v-list-item-content>
                                    <v-list-item-title v-text="item.title"></v-list-item-title>
                                </v-list-item-content>
                            </template>
                            
                            
                            <template v-for="(child, y) in item.items">
                                <v-list-item
                                    v-if="child.subGroups"
                                    :key="`child-${y}`"
                                    v-show="child.access"
                                    class="mb-n2 ml-n6"
                                >
                                    <v-list-item-content>
                                        <v-list-group
                                            :key="`subGroup-${y}`"
                                            color="teal"
                                            v-model="child.active"
                                            :prepend-icon="child.action"
                                            no-action
                                            sub-group
                                        >
                                            <template v-slot:activator>
                                                <v-list-item-content>
                                                    <v-list-item-title v-text="child.title"></v-list-item-title>
                                                </v-list-item-content>
                                            </template>
                                            <template v-for="(subGroup, z) in child.subGroups">
                                                <v-list-item
                                                    :key="`subGroup-${z}`"
                                                    :to="{ name: subGroup.link }"
                                                    v-show="subGroup.access"
                                                    link
                                                    :disabled="subGroup.disabled"
                                                >
                                                    <v-list-item-icon>
                                                        <v-icon color="teal lighten-1">{{ subGroup.action }}</v-icon>
                                                    </v-list-item-icon>
                                                    <v-list-item-content>
                                                        <v-list-item-title>
                                                            {{ subGroup.title }}
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </template>
                                        </v-list-group>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item
                                    v-else
                                    :key="`child-${y}`"
                                    :to="{ name: child.link }"
                                    v-show="child.access"
                                    link
                                    :disabled="child.disabled"
                                    class="ml-n6"
                                >
                                    <v-list-item-icon>
                                        <v-icon color="teal lighten-1">{{ child.action }}</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            {{ child.title }}
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                        
                        </v-list-group>
                    </template>
                
                </v-list>
                <template v-slot:append>
                    <v-divider/>
                    <v-row dense>
                        <v-col cols="12">
                            <v-list dense>
                                <v-list-item
                                    v-if="hasParamAccess()"
                                    @click="$router.push({ name: 'parameters' })"
                                >
                                    <v-list-item-action>
                                        <v-icon>mdi-cog-outline</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-title>Paramétrage</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="$router.push({ name: 'reset_password' })">
                                    <v-list-item-action>
                                        <v-icon>mdi-lock-reset</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-title> Modifier mot de passe</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="logout">
                                    <v-list-item-action>
                                        <v-icon>mdi-logout</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-title> Déconnecter</v-list-item-title>
                                </v-list-item>
                            
                            </v-list>
                        </v-col>
                    </v-row>
                </template>
            </v-navigation-drawer>
        </nav>
        <v-main>
            
            <router-view/>
        </v-main>
        <v-snackbar
            v-model="snackbar"
            color="red"
            top
            right
            timeout="10000"
        >
            Nouvelles Notifications
            
            <template v-slot:action="{ attrs }">
                <v-btn
                    color="white"
                    text
                    v-bind="attrs"
                    @click="snackbar = false"
                >
                    {{ $t('common.close') }}
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>